/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { Button } from "../button/button";
import { WarningItem } from "../warning-item/warning-item";
import { ReactComponent as IconVisa } from "../../assets/icons/nav/icon_visa.svg";
import { Modal } from '../modal/modal';
import { Organization } from "../../models/interfaces/organization";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import OrganizationService from "../../utilities/services/organization-service";
import CancellationDialogBox from "../cancellation-dialog-box/cancellation-dialog-box";
import PortalProgressBar from "../portal-progress-bar/portal-progress-bar";
import { OrganizationSubscription } from "../../models/interfaces/organization-subscription";
import OrganizationSubscriptionService from "../../utilities/services/organization-subscription-service";
import { Loader } from "../loader/loader";
import { useHistory } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutFormCreate from "../subscription/checkout-form-create";
import { PlanType } from "../../models/enumerations/plan-type";
import SavePaymentMethodForm from "../subscription/save-payment-method-form";
import moment from "moment";
import SubscriptionService from "../../utilities/services/subscription-service";
import UserUtil from "../../utilities/user-util";
import EnterpriseContactUs from "../subscription/enterprise-contact-us";
import { createLogger } from "../../utilities/logger";
import { PlanId } from "../../models/enumerations/plan-id";
import { AddOnId } from "../../models/enumerations/add-on-id";
import { enqueueSnackbar } from "notistack";
import UserService from "../../utilities/services/user-service";
import { User } from "../../models/interfaces/user";
import { useTranslation } from 'react-i18next';
import { Tabs } from "../../models/enumerations/tabs";
import { PaymentCycle } from "../../models/enumerations/payment-cycle";
import { PaymentCycleLabel } from "../../models/payment-cycle";
import { OrganizationType } from "../../models/enumerations/organization-type";
import BillingApiService from "../../utilities/services/billing-service";
import { SummaryTile } from "../summary-tile/summary-tile";
const log = createLogger("Billing");


interface BillingProps {
  products: any[];
}
const COMPONENT_CLASS = "c-billing";

const Billing: React.FC<BillingProps> = (props: BillingProps) => {
  const {
    products
  } = props;
  const [userCount, setUserCount] = useState(0);
  const [userLimit, setUserLimit] = useState(0);
  const [licenseCount, setLicenseCount] = useState(0);
  const [licenseLimit, setLicenseLimit] = useState(0);
  const [openCancel, setOpenCancel] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isPaymentSuccess] = useState(false);
  const [isPaymentUpdatedSuccess] = useState(false);
  const [isPaymentUpdateFailed] = useState(false);
  const [paymentFailedModalOpen, setPaymentFailedModalOpen] = useState<boolean>(false);
  const [paymentSuccessModalOpen, setPaymentSuccessModalOpen] = useState<boolean>(false);
  const [paymentUpdatedSuccessModalOpen] = useState<boolean>(false);
  const [isPaymentFail] = useState(false);
  const [upgradeModalOpen, setUpgradeModalOpen] = useState<boolean>(false);
  const [isUpgrading] = useState(false);
  const [organization, setOrganization] = useState<Organization>();
  const [organizationSubscription, setOrganizationSubscription] = useState<OrganizationSubscription>();
  const [getPayment, setGetPayment] = useState<boolean>(false);
  const [, setPaymentFailed] = useState<boolean>(false);
  const [lastFour, setLastFour] = useState<string>();
  const [cardBrand, setCardBrand] = useState<string>();
  const [cardExpiration, setCardExpiration] = useState<string>();
  const { state, setState } = useAuthState();
  const [stripeCustomerFailedPayment, setStripeCustomerFailedPayment] = useState<boolean>();
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY as string);
  const history = useHistory();
  const [, setPaymentSuccessful] = useState<boolean>(false);
  const [invoices, setInvoices] = useState<any[]>();
  const [paymentUpdateFailed, setPaymentUpdateFailed] = useState<boolean>(false);
  const [paymentUpdateSuccessful, setPaymentUpdateSuccessful] = useState<boolean>(false);
  const [isSubscriptionCancelled, setIsSubscriptionCancelled] = useState<boolean>(false);
  const [openConfirmResubscribe, setOpenConfirmResubscribe] = useState(false);
  const [plan, setPlan] = useState<any>();
  const [contactUsEnterpriseOpen, setContactUsEnterpriseOpen] = useState(false);
  const [accountHolder, setAccountHolder] = useState<User>();
  const [reloadTrigger, setReloadTrigger] = useState(0);
  const isAccountHolder = UserUtil.isAccountHolder(state.user);
  const isSuperAdmin = UserUtil.isSuperAdmin(state.claims);
  const { t } = useTranslation();
  const [isWarningVisible, setIsWarningVisible] = useState(true);

  // Format the price above to USD using the locale, style, and currency.
  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  useEffect(() => {
    if (state.organization?.id == null) {
      return;
    }

    const getOrganization = async () => {
      await OrganizationService.getSnapshot(state.organization.id!, (organization: Organization) => {
        setOrganization(organization);
        setIsLoading(false);
      });
    }
    getOrganization();

  }, [state.organization?.id]);

  useEffect(() => {
    const load = async () => {
      setIsLoading(true);
      if (organization?.id == null) {
        setIsLoading(false);
        return;
      }

      try {
        const subscription = await OrganizationSubscriptionService.getByOrganizationId(organization.id);
        if (subscription[0] && subscription[0].organizationId) {
          setOrganizationSubscription(subscription[0]);

          if (subscription[0].stripePlanSubscription) {
            const details = await BillingApiService.getSubscriptionDetails({
              subscriptionId: subscription[0].stripePlanSubscription,
            });
            setIsSubscriptionCancelled(details.cancelAtPeriodEnd);
          }
        }
      } catch (err) {
        log.error("Failed to load billing subscription", {
          exception: err,
          organizationId: state.organization?.id,
        });
      } finally {
        setIsLoading(false);
      }

    };

    load();
  }, [state.organization?.id, organization, reloadTrigger]);
  // Triggers when on initial, if org plan changes, or if payment was updated.
  // Gets the customer & their subscription. Gets credit card info attached to subscription for the Payment Method UI
  useEffect(() => {
    const loadBillingSummary = async () => {
      try {
        const holder = await UserService.get(
          organization?.accountHolderId ? organization.accountHolderId : ""
        );

        if (!holder?.email || !organizationSubscription) {
          return;
        }

        setAccountHolder(holder);

        const summary = await BillingApiService.getBillingSummary({
          email: holder.email,
          stripePlanSubscription: organizationSubscription.stripePlanSubscription,
          stripeAddOnSubscription: organizationSubscription.stripeAddOnSubscription,
        });

        setIsSubscriptionCancelled(summary.isSubscriptionCancelled);
        setStripeCustomerFailedPayment(summary.stripeCustomerFailedPayment);
        setLastFour(summary.paymentMethod.lastFour ?? undefined);
        setCardExpiration(summary.paymentMethod.expiration ?? undefined);
        setCardBrand(
          summary.paymentMethod.brand
            ? capitalizeFirstLetter(summary.paymentMethod.brand)
            : undefined
        );
      } catch (e) {
        log.error("Failed to load billing summary", {
          exception: e,
          organizationId: organization?.id,
        });
      }
    };

    if (organization && organizationSubscription) {
      loadBillingSummary();
    }
  }, [paymentUpdatedSuccessModalOpen, organizationSubscription, paymentUpdateSuccessful, organization]);
  useEffect(() => {
    const getBillingHistory = async () => {
      if (!accountHolder?.email || !organizationSubscription) {
        return;
      }

      try {
        const invoiceResponse = await BillingApiService.getBillingInvoices({
          email: accountHolder.email,
          stripePlanSubscription: organizationSubscription.stripePlanSubscription,
          stripeAddOnSubscription: organizationSubscription.stripeAddOnSubscription,
        });

        const eligibleProducts = products.filter((item) =>
          item.product.id === PlanId.Business ||
          item.product.id === PlanId.Core ||
          item.product.id === PlanId.Pro ||
          item.product.id === AddOnId.License ||
          item.product.id === AddOnId.User
        );

        const structuredInvoices = invoiceResponse.invoices
          .map((invoice) => {
            const matchingProduct = eligibleProducts.find(
              (item: any) => item.product.id === invoice.productId
            );

            if (!matchingProduct) {
              return null;
            }

            return {
              product_id: matchingProduct.product.id,
              product_name: matchingProduct.product.data.name,
              effective_at: invoice.effectiveAt,
              amount_paid: invoice.amountPaid,
              hosted_invoice_url: invoice.hostedInvoiceUrl,
            };
          })
          .filter(Boolean)
          .sort((a: any, b: any) => (b.effective_at ?? 0) - (a.effective_at ?? 0));
        setInvoices(structuredInvoices);
      } catch (e) {
        log.error("Failed to load billing history", {
          exception: e,
          organizationId: organization?.id,
        });
      }
    };

    if (products && accountHolder && organizationSubscription) {
      getBillingHistory();
    }
  }, [products, accountHolder, organizationSubscription]);


  useEffect(() => {
    if (organizationSubscription && organizationSubscription.plan) {
      setPlan(organizationSubscription.plan.value);
    }
  }, [organizationSubscription]);

  useEffect(() => {
    const closeModal = async () => {
      if (paymentUpdateSuccessful || paymentUpdateFailed) {
        setOpenEdit(false);
      }
    }
    closeModal();

  }, [paymentUpdateFailed, paymentUpdateSuccessful])

  useEffect(() => {
    if (organization) {
      setUserCount(Number(organization!.userCount));
      setUserLimit(Number(organization!.userLimit));
      setLicenseCount(organization!.mySymmioLicenseCount ? organization.mySymmioLicenseCount : 0); //TODO: Add license count
      setLicenseLimit(Number(organization!.mySymmioLicense));
    }
  }, [organization, state.organization?.id]);

  const calculatePercentage = () => {
    return (userCount / userLimit) * 100;
  };




  const handleWarningClose = () => {
    setIsWarningVisible(false);
  }

  const handleTrialWarningClose = () => {
    setState((state) => ({
      ...state,
      ...{ yellowTrialWarning: false, redTrialWarning: false },
    }));
  }

  const getTrialWarningMessage = () => {
    if (!organizationSubscription || organizationSubscription.plan?.value !== PlanType.Trial) {
      return;
    }
    const targetDate = moment(organizationSubscription.renewDate); // Parse the ISO string
    const daysAway = targetDate.diff(moment(), 'days');
    if (state.yellowTrialWarning) {
      return <WarningItem
        textColor="#121622"
        iconColor="#FFC79C"
        backgroundColor="#FFF4E4"
        title={t('billing.warnings.warn5_head', { days: daysAway })}
        text={t('billing.warnings.warn5_desc', { date: moment(organizationSubscription.renewDate).format("MMMM D, YYYY") })}
        buttonText={t('buttons.btn_upgradeAccount')}
        onClose={handleTrialWarningClose}
        onButtonClick={() => history.push(`settings/upgrade`)}
        isButtonDisabled={!UserUtil.isAccountHolder(state.user)}
      />
    } else if (state.redTrialWarning) {
      return <WarningItem
        iconColor="#E7514F"
        backgroundColor="#FFE9E5"
        title={t('billing.warnings.warn5_head', { days: daysAway })}
        text={t('billing.warnings.warn5_desc', { date: moment(organizationSubscription.renewDate).format("MMMM D, YYYY") })}
        buttonText={t('buttons.btn_upgradeAccount')}
        onClose={handleTrialWarningClose}
        onButtonClick={() => history.push(`settings/upgrade`)}
        isButtonDisabled={!UserUtil.isAccountHolder(state.user)}
      />
    }
  }

  const getWarningMessage = () => {
    var percentage = calculatePercentage();
    if (isWarningVisible && (percentage >= 75 && percentage <= 89)) {
      return <WarningItem
        textColor="#121622"
        iconColor="#FFC79C"
        backgroundColor="#FFF4E4"
        title={t('billing.warnings.warn1_head')}
        text={t('billing.warnings.warn123_desc')}
        buttonText={t('buttons.btn_upgrade')}
        onClose={handleWarningClose}
        onButtonClick={() => history.push(`settings/upgrade`)}
        isButtonDisabled={!UserUtil.isAccountHolder(state.user)}
      />
    } else if (isWarningVisible && (percentage > 89 && percentage <= 99)) {
      return <WarningItem
        iconColor="#E7514F"
        backgroundColor="#FFE9E5"
        title={t('billing.warnings.warn2_head')}
        text={t('billing.warnings.warn123_desc')}
        buttonText={t('buttons.btn_upgrade')}
        onClose={handleWarningClose}
        onButtonClick={() => history.push(`settings/upgrade`)}
        isButtonDisabled={!UserUtil.isAccountHolder(state.user)}
      />
    } else if (isWarningVisible && (percentage === 100 || percentage > 100)) {
      return <WarningItem
        iconColor="#E7514F"
        backgroundColor="#FFE9E5"
        title={t('billing.warnings.warn3_head')}
        text={t('billing.warnings.warn123_desc')}
        buttonText={t('buttons.btn_upgrade')}
        onClose={handleWarningClose}
        onButtonClick={() => history.push(`settings/upgrade`)}
        isButtonDisabled={!UserUtil.isAccountHolder(state.user)}
      />
    }
  }

  // const deeplinks = [{ name: "Symmio Enterprise Yearly", date: "May 3rd, 2023", amount: "$15,000.00" }, { name: "Symmio Business Monthly", date: "December 21st, 2023", amount: "$150.00" }];

  const getRenewDate = () => {
    if (organizationSubscription && organizationSubscription.renewDate) {
      const date = new Date(organizationSubscription.renewDate);

      return moment(date).format("MMMM DD, yyyy");
    }
  }

  const getPaymentFailedMessage = () => {
    return <WarningItem
      iconColor="#E7514F"
      backgroundColor="#FFE9E5"
      title={t('billing.warnings.warn4_head')}
      text={t('billing.warnings.warn4_desc')}
      buttonText={t('buttons.btn_updatePayment')}
      onClose={handleWarningClose}
      onButtonClick={() => { setGetPayment(true); setUpgradeModalOpen(true); }}
    />
  }

  const capitalizeFirstLetter = (test: string) => {
    return test.charAt(0).toUpperCase() + test.slice(1);
  }

  const isTrialSubscription = organizationSubscription?.plan?.value === PlanType.Trial
    || organizationSubscription?.plan?.value === PlanType.EnterpriseTrial
    || organizationSubscription?.accountType?.value === OrganizationType.Trial;

  const planLabel = organizationSubscription?.plan?.label;

  const planTitle = planLabel == null || isTrialSubscription || organizationSubscription?.paymentCycle == null
    ? planLabel
    : `${planLabel} ${PaymentCycleLabel[organizationSubscription.paymentCycle.value as PaymentCycle]}`;

  return (
    <div className={COMPONENT_CLASS}>
      <Loader isVisible={isLoading} />
      {getTrialWarningMessage()}
      {getWarningMessage()}
      { // TODO: This will have to change to only when a recurring payment fails
        stripeCustomerFailedPayment &&
        getPaymentFailedMessage()
      }
      {getPayment && stripePromise &&
        <Modal
          isOpen={upgradeModalOpen}
          isLoading={isUpgrading}
          onClose={() => {
            setUpgradeModalOpen(false);
          }}
          title={t('billing.completeUpgrade')}>
          <Elements stripe={stripePromise} options={{ mode: 'subscription', amount: 50, currency: 'usd' }}>
            <CheckoutFormCreate isLoading={isLoading} setIsLoading={setIsLoading} paymentSuccessful={setPaymentSuccessful} paymentFailed={setPaymentFailed} returnUrl={`/settings?active=${Tabs.Billing}`} products={products} />
          </Elements>
        </Modal>
      }
      <Modal
        isOpen={paymentSuccessModalOpen}
        isLoading={isPaymentSuccess}
        onClose={() => {
          setPaymentSuccessModalOpen(false);
          history.replace(`/settings`)
        }}
        title={t('billing.planUpgraded')}
        defaultCenterModal={true}
        submitButtonText={t('buttons.btn_continue')}
        onSubmit={() => {
          setPaymentSuccessModalOpen(false);
          history.replace(`/settings`)
        }}>
        <div>
          <p><b>{t('billing.thankYou_msg')}</b></p>
          <p>{t('billing.emailConfirmation')}</p>
        </div>
      </Modal>
      <Modal
        isOpen={contactUsEnterpriseOpen}
        isLoading={false}
        onClose={() => {
          setContactUsEnterpriseOpen(false);
        }}
      >
        <EnterpriseContactUs title={t('billing.changePlan')} isEnterprise={true} />
      </Modal>
      <Modal
        isOpen={paymentUpdateSuccessful}
        isLoading={isPaymentUpdatedSuccess}
        onClose={() => {
          setPaymentUpdateSuccessful(false);
        }}
        defaultCenterModal={true}
        submitButtonText={t('buttons.btn_continue')}
        onSubmit={() => {
          setPaymentUpdateSuccessful(false);
        }}
        title={t('billing.paymentMethodUpdated')}>
        <div className={`${COMPONENT_CLASS}__modal-wrapper`}>
          <div className={`${COMPONENT_CLASS}__modal-content`}>
            <p><b>{t('billing.paymentMethodUpdated_desc')}</b></p>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={paymentUpdateFailed}
        isLoading={isPaymentUpdateFailed}
        onClose={() => {
          setPaymentUpdateFailed(false);
        }}
        title={t('billing.paymentMethodFailed')}
        defaultCenterModal={true}
        submitButtonText={t('buttons.btn_continue')}
        onSubmit={() => {
          setPaymentUpdateFailed(false);
        }}>
        <div className={`${COMPONENT_CLASS}__modal-wrapper`}>
          <div className={`${COMPONENT_CLASS}__modal-content`}>
            <p><b>{t('billing.paymentMethodFailed_desc')}</b></p>
          </div>
        </div>
      </Modal >
      <Modal
        isOpen={paymentFailedModalOpen}
        isLoading={isPaymentFail}
        onClose={() => {
          setPaymentFailedModalOpen(false);
          history.replace(`/settings`)
        }}
        title={t('billing.paymentMethodDeclined')}
        submitButtonText={t('buttons.btn_continue')}
        onSubmit={() => {
          setPaymentFailedModalOpen(false);
          history.replace(`/settings`)
        }}
        defaultCenterModal={true}>
        <div className={`${COMPONENT_CLASS}__modal-wrapper`}>
          <div className={`${COMPONENT_CLASS}__modal-content`}>
            <p><b>{t('billing.paymentMethodDeclined_desc1')}</b></p>
            <p>{t('billing.paymentMethodDeclined_desc2')}</p>
            <p>{t('billing.paymentMethodDeclined_desc3')}</p>
          </div>
        </div>
      </Modal>

      <div className={`${COMPONENT_CLASS}__status`}>
        <div className={`${COMPONENT_CLASS}__status__container`}>
          {isSubscriptionCancelled
            ?
            <SummaryTile
              className={`${COMPONENT_CLASS}__status__tile`}>
              <p className="text-left">
                <strong>{t('billing.planCancelled_1')}</strong>
                <br />
                <br />
                <p dangerouslySetInnerHTML={{ __html: t('billing.planCancelled_2', { renewDate: getRenewDate() }) }}></p>
                <br />
                <br />
                <p dangerouslySetInnerHTML={{ __html: t('billing.planCancelled_3') }}></p>
              </p>
              {(isAccountHolder || isSuperAdmin) &&
                <div className={`${COMPONENT_CLASS}__actions`} style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', justifyContent: 'flex-end' }}>
                  <Button
                    buttonText={t('buttons.btn_resubscribe')}
                    onClick={() => setOpenConfirmResubscribe(true)} />
                </div>
              }
            </SummaryTile>
            :
            <SummaryTile
              className={`${COMPONENT_CLASS}__status__tile`}>
              <div className={`${COMPONENT_CLASS}__status__tile-header`}>
                <h1 className={`${COMPONENT_CLASS}__status__tile-title`}>{planTitle}</h1>
                <p className={`label-small ${COMPONENT_CLASS}__status__tile-subtitle`}>
                  {isTrialSubscription
                    ? t('billing.trialEnd', { renewDate: getRenewDate() })
                    : t('manageSubscription.nextPayment', { nextPayment: getRenewDate() })}
                </p>
              </div>
              <div className={`${COMPONENT_CLASS}__status__tile-main`}>
                <PortalProgressBar total={userLimit} currentProgress={userCount} headerText={t('licenseUserRemoval.usedUserProgress', { userCount: userCount, userLimit: userLimit })} />
                {
                  organizationSubscription?.mySymmioLicense && (
                    <PortalProgressBar total={licenseLimit} currentProgress={licenseCount} headerText={t('licenseUserRemoval.usedLicenseProgress', { mySymmioLicenseCount: licenseCount, mySymmioLicenseLimit: licenseLimit })} />
                  )
                }
              </div>
              {(isAccountHolder || isSuperAdmin) && organizationSubscription?.plan?.value !== PlanType.Partner &&
                <div className={`${COMPONENT_CLASS}__actions`}>
                  {(plan === PlanType.Enterprise) ? (
                    <>
                      <p className={`c-portal-progress-bar__header`}>{t('billing.contactUs')}</p>
                      <Button
                        buttonText={t('buttons.btn_contactUs')}
                        onClick={() => { setContactUsEnterpriseOpen(true); }} />
                    </>
                  ) : (
                    <>
                      {organizationSubscription?.plan?.value !== PlanType.EnterpriseTrial && organizationSubscription?.plan?.value !== PlanType.Trial &&
                        <Button
                          type="link"
                          disabled={!isAccountHolder || organizationSubscription?.plan?.value === PlanType.EnterpriseTrial}
                          inputClassName={`${COMPONENT_CLASS}__actions__cancel`}
                          onClick={() => { setOpenCancel(true); }}
                          buttonText={t('buttons.btn_cancelPlan')}
                          inputStyle={{ backgroundColor: '#F3F3F4', paddingLeft: '0px' }} />

                      }
                      <Button
                        buttonText={t('buttons.btn_changePlan')}
                        disabled={!isAccountHolder}
                        onClick={() => history.push(`settings/upgrade`)} />
                    </>
                  )}
                </div>
              }
            </SummaryTile>
          }

          {
            organizationSubscription?.plan?.value !== PlanType.Partner && (
              <SummaryTile
                className={`${COMPONENT_CLASS}__status__tile`}>
                <div className={`${COMPONENT_CLASS}__status__tile-header`}>
                  <h1 className={`${COMPONENT_CLASS}__status__tile-title`}>{t('billing.paymentMethod')}</h1>
                </div>
                <div className={`${COMPONENT_CLASS}__status__tile-main`}>
                  {(plan === PlanType.Enterprise || plan === PlanType.Trial || plan === PlanType.EnterpriseTrial) && (
                    <>
                      <p className={`c-portal-progress-bar__header`}>{t('billing.invoice')}</p>
                      {plan === PlanType.Enterprise && (
                        <p className={`${COMPONENT_CLASS}__custom-payment-message`}>{t('billing.customPlan')}</p>

                      )}
                      {(plan === PlanType.Trial || plan === PlanType.EnterpriseTrial) && (
                        <p className={`${COMPONENT_CLASS}__custom-payment-message`}>{t('billing.trialPlan')}</p>

                      )}
                    </>
                  )
                  }
                  {(plan === PlanType.Business || plan === PlanType.Core || plan === PlanType.Pro) && (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                      <div style={{ display: 'flex', width: '6rem', height: '3.5rem', backgroundColor: 'white', borderRadius: '10px', alignItems: 'center', justifyContent: 'center' }}>
                        <IconVisa />
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '2rem' }}>
                        <h1 style={{ fontSize: '15px', fontWeight: 'bold' }}>{t('billing.cardDetails', { cardBrand: cardBrand, lastFour: lastFour })}</h1>
                        <h1 style={{ fontSize: '15px', marginBottom: '0px' }}>{t('billing.cardExpiry', { cardExpiration: cardExpiration })}</h1>
                      </div>
                    </div>
                  )}
                </div>
                <div className={`${COMPONENT_CLASS}__actions`}>
                  <div></div>
                  <Button
                    buttonText={`${plan === PlanType.Trial ? t('buttons.btn_add') : t('buttons.btn_edit')}`}
                    disabled={plan === PlanType.Enterprise || plan === PlanType.Trial || plan === PlanType.EnterpriseTrial || !isAccountHolder}
                    onClick={() => {
                      setOpenEdit(true);
                    }} />
                </div>
              </SummaryTile>
            )
          }
          {plan !== PlanType.Trial && invoices && invoices.length > 0 && (
            <>
              <h3 className={`${COMPONENT_CLASS}__invoice-information-header`}>{t('billing.billingHistory')}</h3>
              <div className={`${COMPONENT_CLASS}__invoice-container`}>
                {invoices.map((invoice: any, index: number) => {
                  return (
                    <div className={`${COMPONENT_CLASS}__invoice`} key={`billing_history_${index}`}>
                      <div className={`${COMPONENT_CLASS}__invoice-information`}>
                        <div className={`${COMPONENT_CLASS}__invoice-information-name`}>{invoice.product_name}</div>
                        <div className={`${COMPONENT_CLASS}__invoice-information-date`}>{`${moment(new Date(invoice.effective_at * 1000)).format('MMMM D, Y')}`}</div>
                        <div className={`${COMPONENT_CLASS}__invoice-information-price`}>{USDollar.format((invoice.amount_paid / 100))}</div>
                      </div>

                      <div className={`${COMPONENT_CLASS}__invoice-button-container`}>
                        <Button
                          buttonText={t('buttons.btn_viewInvoice')}
                          buttonStyle="secondary"
                          onClick={(event) => {
                            event.stopPropagation();
                            window.open(invoice.hosted_invoice_url, "_blank")
                          }}
                        />
                      </div>
                    </div>
                  )

                })}
              </div>
            </>
          )
          }

          {openCancel &&
            <CancellationDialogBox
              isOpen={openCancel}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              onClose={setOpenCancel}
              onCancelAction={() => setReloadTrigger(prev => prev + 1)}
              title={t('billing.cancelTitle')}
            />
          }

          <Modal
            isOpen={openEdit}
            isLoading={isLoading}
            onClose={() => {
              setOpenEdit(false);
            }}
          >
            <Elements stripe={stripePromise} options={{ mode: 'setup', currency: 'usd' }}>
              <SavePaymentMethodForm setOpenEdit={setOpenEdit} updateFailed={setPaymentUpdateFailed} updateSuccessful={setPaymentUpdateSuccessful} returnUrl={`/settings?active=${Tabs.Billing}&edit_payment_only=true`} setIsLoading={setIsLoading} />
            </Elements>
          </Modal>

          <Modal
            isOpen={openConfirmResubscribe}
            isLoading={isLoading}
            onClose={setOpenConfirmResubscribe}
            title={t('billing.reactivateTitle')}
            defaultCenterModal={true}
            onSubmit={async () => {
              try {
                setIsLoading(true);
                await SubscriptionService.handleSubscriptionReactivation(organization?.id);
                log.info("Subscription resubscribed", {
                  organizationId: organization?.id,
                });
                enqueueSnackbar(t('billing.subReactivated'), { variant: "toast", width: "450px" });
                setReloadTrigger(prev => prev + 1);
              } catch (err: any) {
                log.error("Failed to resubscribe", {
                  exception: err,
                  organizationId: organization?.id,
                });
                enqueueSnackbar(err);
              } finally {
                setIsLoading(false);
              }

              setOpenConfirmResubscribe(false);
            }}
            submitButtonText={t('buttons.btn_resubscribe')}>
            <div>
              <p dangerouslySetInnerHTML={{ __html: t('billing.resubscribe') }}></p>
              <br />
            </div>
          </Modal>
        </div >
      </div>
    </div >

  );
}
export default Billing;